import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import shipingService from "../services/shiping-service";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import { getValueByColumn } from "ka-table/Utils/DataUtils";
import "jspdf-autotable";
import jsPDF from "jspdf";
const tablePropsInit = {
  columns: [
    { key: "fac_id", title: "Facility Id" },
    { key: "fac_name", title: "Facility Name" },
    { key: "fac_code", title: "Dcode" },
    { key: "fac_workflow", title: "Sorter Code" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
};
const FacNotReady = () => {
  const [loading, setLoading] = useState(false);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  let dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      try {
        let resp = await shipingService.getNotReadyFacilities();
        if (resp.length > 0) {
          resp.sort((d1, d2) => d1.fac_workflow - d2.fac_workflow);
          dispatch1(updateData(resp));
        } else {
          const { hide } = cogoToast.error("No Records Found.", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
          setLoading(false);
          dispatch1(updateData());
        }
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving not ready facility. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
      setLoading(false);
    }
  };
  const exportClick = () => {
    const doc = new jsPDF();
    const head = [["Facility Id", "Facility Name", "Dcode", "Sorter Code"]];
    if (tableProps.data) {
      const body = tableProps.data.map((d) =>
        tableProps.columns.map((c) => getValueByColumn(d, c))
      );
      doc.autoTable({
        margin: 1,
        headStyles: { fillColor: "#F1F5F7", textColor: "#747D86" },
        alternateRowStyles: { fillColor: "#F9FBFC" },
        head,
        body,
      });
    }
    doc.save("NotReadyFacilities.pdf");
  };
  return (
    <div>
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div></div>
      <div className={`inline-block customtop w-full notReadyTable`}>
        <div className="w-full text-right">
          <span>
          <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch1(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 h-10 mx-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 right-5 top-1 bottom-3"
              ></img>
            </span>
            <button
              onClick={() => exportClick()}
              class="bg-header_bg rounded py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6 mr-2"
            >
              Download
            </button>
            
          </span>
        </div>
        <div className="p-2 text-xs gridList overflow-x-auto">
          <form>
            <Table {...tableProps} dispatch={dispatch1} />
          </form>
        </div>
      </div>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(FacNotReady)
);
